// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>3</span>&nbsp;&nbsp;Look upon me and answer, O Lord my God;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;lighten my eyes, lest I sleep in death;<br> </p> </div></div>";
// Exports
module.exports = code;